<template>
    <div class="animated fadeIn">

        <b-alert show variant="primary" v-if="exportResult" v-html="exportResult"></b-alert>

        <b-tabs  nav-wrapper-class="w-40">
            <b-tab active>
                <template slot="title">
                    <i class="fa fa-download"></i> Экспорт путевок
                </template>

                <p>
                    Выгрузка путевок в формате XML
                </p>

                <b-form>

                    <report-types
                        v-model="report_type"
                        :types="['active_finished', 'annulaed', ]"
                        :invalid_feedback="veeErrors.first('report_type')"
                        :validation_state="validateState('report_type')"
                        v-validate="{required:true}"
                        name="report_type"
                        data-vv-as="'Тип экспорта'"
                        data-vv-name="report_type"
                    ></report-types>


                    <report-dates
                        v-model="date_type"
                        :types="['checkin', 'checkout', 'invoice_payed', 'any_period_day']"
                        :invalid_feedback="veeErrors.first('date_type')"
                        :validation_state="validateState('date_type')"
                        v-validate="{required:true}"
                        name="date_type"
                        data-vv-as="'Период отчета'"
                        data-vv-name="date_type"
                    ></report-dates>

                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <b-form-group label="Объект" :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Компания" :label-cols="3" :horizontal="false">
                        <v-select v-model="company_id" @input="agent_id=null" :options="_companies" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group
                        label=""
                        label-for="exporttype3" :label-cols="3" :horizontal="false"
                        description='Путевки с отметкой "квота" не выгружаются. "Хотя бы одна дата путевки" - это то что называлось "с учетом переходного периода". '
                    >
                        <b-button block variant="primary" @click="doExportVouchers"><i class="fa fa-download"></i> Выгрузить</b-button>
                    </b-form-group>

                </b-form>
            </b-tab>
        </b-tabs>

        <b-card no-body v-if="exportResult">
            <div slot="header">
                <strong><a :href="exportUrl" target="_blank">{{ exportUrl }}</a> </strong>

            </div>

            <b-card-body>
                <b-form-textarea
                    id="textarea"
                    v-model="exportReport"
                    rows="6"
                    max-rows="15"
                ></b-form-textarea>
            </b-card-body>

        </b-card>

        <b-card v-if="reports.length">
            <ul>
                <li v-for="r in reports">
                    <a :href="r.report_url" target="_blank">{{r.report_title}}</a>
                </li>
            </ul>
        </b-card>

        WID=48e9027b-16bc-46d9-9520-ba18ea1ab383

    </div>
</template>

<script>
    import { functions } from '@/functions';
    import { functions_loaders } from '@/functions_loaders';
    import { functions_company } from '@/functions/company.js';
    import { functions_hotel } from '@/functions/hotel.js';
    import { functions_report } from '@/functions_report.js';
    import ReportTypes from '@/components/ReportTypes';
    import ReportDates from '@/components/ReportDates';

    export default {
        name: 'NsbBuhDataExport',
        mixins: [functions, functions_loaders, functions_company, functions_hotel, functions_report],
        components: {
            ReportTypes,
            ReportDates
        },
        data: function () {
            return {
                hotel_id: null,
                company_id: null,
                date_range:null,
                report_type:null,
                date_type:null,

                // agent_id: null,
                // city_id: null,
                // use_profkurort:true,
                // use_unfilled:false,
                // only_errors: false,
                // only_selected_vouchers: false,

                report_types:[
                    {id:0, title:''},
                    {id:1, title:'Исполняемые и исполненные путевки'},
                    {id:2, title:'Аннулированные путевки'},
                ],

                date_types:[

                    {id:1, title:'По дате заезда'},
                    {id:2, title:'По дате выезда'},
                    {id:4, title:'По дате покупки'},
                    {id:3, title:'С учетом переходного периода'}
                ],

                exportResult: null,
                exportReport: null,
                exportUrl: null,
            }
        },
        methods: {
            doExportVouchers: function() {

                this.$validator.validateAll().then((result) => {
                    if (result)
                        this.exportBuhVouchers(
                            this.date_range_start,
                            this.date_range_end,
                            this.report_type,
                            this.date_type,
                            this.hotel_id,
                            this.company_id
                        );
                });
            },
            resetDateRange: function() {
                this.date_range = null;
            },
        },
        computed: {

            _hotels: function () {
                let self = this;
                return this.hotels;
            },

            _companies: function () {
                let self = this;
                return this.companies.filter(function(company) {
                    return company.type & 1 ;
                });
            },

            date_range_start: function () {
                if (this.date_range !== null)
                    return new Date(this.date_range.start).toLocaleDateString()
                return null;
            },

            date_range_end: function () {
                if (this.date_range !== null)
                    return new Date(this.date_range.end).toLocaleDateString()
                return null;
            },
        },
        created: function() {
            this.loadHotels();
            this.loadCompanies();
        }
    };
</script>

<style lang="scss">
</style>
